import * as React from 'react';
import { getAdministrationDomains, useActions } from './administrationActions';
import { Table } from '../View/Tabular/tabular';
import { Filters } from '../Filters/filters';
import { Add } from 'rcd-cpp-ui/ui/button';
import { ConfirmModal } from '../ConfirmModal/confirmModal';
import { useSelector } from '../../utils/useSelector';
import AccessControl from '../AccessControl/accessControl';
import { AdminDomain } from '../../enums/AdminDomain';
import { StagedTagsActions } from './StagedTagsForm/stagedTagsForm';
import { ActionMenu } from '../View/ActionMenu/actionMenu';

export const AdministrationTable = () => {
  const actions = useActions();
  const dataSchema = useSelector(s => s.view.selected.dataSchema);
  const [dataToDelete, setDataToDelete] = React.useState(null);
  return (
    <>
      <AccessControl resource={dataSchema}>
        <Table
          {...actions}
          additionalSchemas={getAdministrationDomains()}
          onDelete={d => setDataToDelete(d)}
          readOnly={dataSchema.id == AdminDomain.stagedTags}
        />
      </AccessControl>
      {!!dataToDelete && (
        <ConfirmModal
          header={'Delete ' + dataToDelete.labels.join(',')}
          onCancel={() => setDataToDelete(null)}
          onDelete={() => {
            actions.deleteData(dataToDelete);
            setDataToDelete(null);
          }}
        >
          Delete {dataToDelete.labels.join(', ')} for
          <b> {dataToDelete.props.name}</b>?
        </ConfirmModal>
      )}
    </>
  );
};

export const AdministrationTools = ({ disabled }) => {
  const { showForm } = useActions();
  const dataSchema = useSelector(s => s.view.selected.dataSchema);
  return (
    <div className="view-tools">
      <PermissionFilters />
      {dataSchema?.id != AdminDomain.stagedTags && (
        <div>
          {!disabled && (
            <Add
              className="view-button"
              buttonSize="small"
              onClick={() => showForm({})}
            />
          )}
        </div>
      )}
      <StagedTagsActions />
      <ActionMenu />
    </div>
  );
};

const PermissionFilters = () => {
  const getAPI = useSelector(s => s?.app?.elFn?.getAPI);
  const filters = useSelector(s => s.view?.filters);
  const schemas = useSelector(s =>
    getAdministrationDomains().concat(s.planning?.selectedWorkspace?.schemas)
  );
  const defaultFilters = useSelector(
    s => s.planning?.selectedWorkspace?.setting?.props?.defaultFilters
  );
  const { setFilter } = useActions();
  return (
    <Filters
      getAPI={getAPI}
      setFilter={setFilter}
      schemas={schemas}
      filters={filters}
      defaultFilters={defaultFilters}
      seeAllFilters={true}
    ></Filters>
  );
};
